/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreEntitiesTournamentStatusSchema = z.enum([
  "Draft",
  "Upcoming",
  "RegistrationOpen",
  "RegistrationClosed",
  "InProgress",
  "Ongoing",
  "Completed",
  "Cancelled",
  "AwaitingBracket",
  "DraftInProgress",
]);
